import StatusBadgeWithReason from './StatusBadgeWithReason';

export default StatusBadgeWithReason;

export type {
  IStatusBadgeDetail,
  IStatusBadgeWithReasonProps,
  StatusBadgeTone
} from './StatusBadgeWithReason';
